module.exports = "/packs/images/svg/ireland/accessibility/poolside_hoist~134802e554f32668893764ec9634980a.svg";